export function convertDate(date) {
    return date
        ? new Date(typeof date === 'string' ? date.replace(/\+([0-9]{2}):?([0-9]{2})/g, '+$1:$2') : date)
        : undefined;
}
export function hideEmail(email) {
    var result = email[0];
    var splitted = email.split('@');
    for (var i = 1; i < splitted[0].length; i++) {
        result += '*';
    }
    return "".concat(result, "@").concat(splitted[1]);
}
export function hideLastNameCharacters(value) {
    var splitted = value.split(' ');
    var lastname = splitted[splitted.length - 1];
    var result = splitted[0];
    for (var i = 1; i < splitted.length - 1; i++) {
        result += " ".concat(splitted[i]);
    }
    result += " ".concat(lastname[0]);
    for (var i = 1; i < lastname.length; i++) {
        result += "*";
    }
    return result;
}
